import Layout from '@/layout/index.vue'
const roles = ['admin']

const routes = [
  {
    path: '/admin/statistics',
    component: Layout,
    alwaysShow: true,
    name: 'Admin-Statistics',
    meta: {
      title: '数据统计',
      icon: 'el-icon-data-analysis',
      roles,
    },
    children: [
      {
        path: 'data-overview',
        component: () => import('@/pages/admin/statistics/DataOverview.vue'),
        name: 'Admin-Statistics-DataOverview',
        meta: {
          title: '数据概览',
          icon: 'el-icon-s-data',
        },
      },
    ],
  },
  {
    path: '/admin/member',
    component: Layout,
    alwaysShow: true,
    name: 'Admin-Member',
    meta: {
      title: '会员管理',
      icon: 'el-icon-user',
      roles,
    },
    children: [
      {
        path: 'manage',
        component: () => import('@/pages/admin/member/Manage.vue'),
        name: 'Admin-Member-Manage',
        meta: {
          title: '会员列表',
          icon: 'el-icon-files',
        },
      },
      {
        path: 'config',
        component: () => import('@/pages/admin/member/Config.vue'),
        name: 'Admin-Member-Config',
        meta: {
          title: '会员配置',
          icon: 'el-icon-setting',
        },
      },
      {
        path: 'log',
        component: () => import('@/pages/admin/member/Log.vue'),
        name: 'Admin-Member-Log',
        meta: {
          title: '会员日志',
          icon: 'el-icon-document',
        },
      },
      {
        path: 'betting',
        component: () => import('@/pages/admin/member/betting.vue'),
        name: 'Admin-Member-Betting',
        meta: {
          title: '投注管理',
          icon: 'el-icon-s-order',
        },
      },
      // {
      //   path: 'recharge-manage',
      //   component: () => import('@/pages/admin/member/RechargeManage.vue'),
      //   name: 'Admin-Member-RechargeManage',
      //   meta: {
      //     title: '充值管理',
      //     icon: 'el-icon-top-right',
      //   },
      // },
      {
        path: 'account-management',
        component: () => import('@/pages/admin/member/AccountManagement.vue'),
        name: 'Admin-Member-AccountManagement',
        meta: {
          title: '账户管理',
          icon: 'el-icon-bank-card',
        },
      },
    ],
  },
  {
    path: '/admin/content',
    component: Layout,
    alwaysShow: true,
    name: 'Admin-Content',
    meta: {
      title: '内容管理',
      icon: 'el-icon-document',
      roles,
    },
    children: [
      {
        path: 'manage',
        component: () => import('@/pages/admin/content/systemNotice.vue'),
        name: 'Admin-Content-Manage',
        meta: {
          title: '系统公告',
          icon: 'el-icon-files',
        },
      },
    ],
  },
  {
    path: '/admin/finance',
    component: Layout,
    alwaysShow: true,
    name: 'Admin-Finance',
    meta: {
      title: '财务管理',
      icon: 'el-icon-money',
      roles,
    },
    children: [
      {
        path: 'deposit-manage',
        component: () => import('@/pages/admin/finance/DepositManage.vue'),
        name: 'Admin-Finance-DepositManage',
        meta: {
          title: '存款管理',
          icon: 'el-icon-bottom-left',
        },
      },
      {
        path: 'withdraw-manage',
        component: () => import('@/pages/admin/finance/WithdrawManage.vue'),
        name: 'Admin-Finance-WithdrawManage',
        meta: {
          title: '提款管理',
          icon: 'el-icon-top-right',
        },
      },
      {
        path: 'manual-score-manage',
        component: () => import('@/pages/admin/finance/ManualScoreManage.vue'),
        name: 'Admin-Finance-ManualScoreManage',
        meta: {
          title: '手动上下分',
          icon: 'el-icon-sort',
        },
      },
      {
        path: 'payment-channel-manage',
        component: () => import('@/pages/admin/finance/PaymentChannelManage.vue'),
        name: 'Admin-Finance-PaymentChannelManage',
        meta: {
          title: '出入款管理',
          icon: 'el-icon-connection',
        },
      },
    ],
  },
  {
    path: '/admin/operation',
    component: Layout,
    alwaysShow: true,
    name: 'Admin-Operation',
    meta: {
      title: '运营管理',
      icon: 'el-icon-s-operation',
      roles,
    },
    children: [
      {
        path: 'activity-manage',
        component: () => import('@/pages/admin/operation/ActivityManage.vue'),
        name: 'Admin-Operation-ActivityManage',
        meta: {
          title: '活动管理',
          icon: 'el-icon-present',
        },
      },
      {
        path: 'ad',
        component: () => import('@/pages/admin/operation/ad/Manage.vue'),
        name: 'Admin-Operation-Ad',
        meta: {
          title: '广告管理',
          icon: 'el-icon-picture-outline',
        },
      },
      {
        path: 'ads-placement',
        component: () => import('@/pages/admin/operation/adsPlacement/Manage.vue'),
        name: 'Admin-Operation-AdsPlacement',
        meta: {
          title: '投放管理',
          icon: 'el-icon-guide',
        },
      },
    ],
  },
  {
    path: '/admin/risk-control',
    component: Layout,
    alwaysShow: true,
    name: 'Admin-RiskControl',
    meta: {
      title: '风控管理',
      icon: 'el-icon-s-tools',
      roles,
    },
    children: [
      {
        path: 'manage-list',
        component: () => import('@/pages/admin/riskControl/manageList/List.vue'),
        name: 'Admin-RiskControl-ManageList',
        meta: {
          title: '风控名单',
        },
      },
      {
        path: 'login-log',
        component: () => import('@/pages/admin/riskControl/loginLog/Manage.vue'),
        name: 'Admin-RiskControl-LoginLog',
        meta: {
          title: '登录日志',
          icon: 'el-icon-document-copy',
        },
      },
    ],
  },
  {
    path: '/admin/game-manage',
    component: Layout,
    alwaysShow: true,
    name: 'Admin-GameManage',
    meta: {
      title: '游戏管理',
      icon: 'el-icon-video-camera',
      roles,
    },
    children: [
      {
        path: 'game-list',
        component: () => import('@/pages/admin/gameManage/GameListManage.vue'),
        name: 'Admin-GameManage-GameList',
        meta: {
          title: '游戏列表',
          icon: 'el-icon-files',
        },
      },
      {
        path: 'game-tag',
        component: () => import('@/pages/admin/gameManage/GameTagManage.vue'),
        name: 'Admin-GameManage-GameTag',
        meta: {
          title: '游戏标签',
          icon: 'el-icon-collection-tag',
        },
      },
    ],
  },
  {
    path: '/admin/agent',
    component: Layout,
    alwaysShow: true,
    name: 'Admin-Agent',
    meta: {
      title: '代理管理',
      icon: 'el-icon-s-grid',
      roles,
    },
    children: [
      // {
      //   path: 'agent-level',
      //   component: () => import('@/pages/admin/agent/agent-level.vue'),
      //   name: 'Admin-Agent-AgentLevel',
      //   meta: {
      //     title: '代理等级',
      //     icon: 'el-icon-star-on',
      //   },
      // },
      {
        path: 'agent-list',
        component: () => import('@/pages/admin/agent/agent-list.vue'),
        name: 'Admin-Agent-AgentList',
        meta: {
          title: '代理列表',
          icon: 'el-icon-files',
        },
      },
    ],
  },
  {
    path: '/admin/site-config',
    component: Layout,
    alwaysShow: true,
    name: 'Admin-Site',
    meta: {
      title: '站点管理',
      icon: 'el-icon-s-home',
      roles,
    },
    children: [
      // {
      //   path: 'base-info',
      //   component: () => import('@/pages/admin/site/baseInfo.vue'),
      //   name: 'Admin-Site-BaseInfo',
      //   meta: {
      //     title: '基础信息',
      //     icon: 'el-icon-setting',
      //   },
      // },
      {
        path: 'faq',
        component: () => import('@/pages/admin/site/faq.vue'),
        name: 'Admin-Site-Faq',
        meta: {
          title: '常见问题',
          icon: 'el-icon-files',
        },
      },
      {
        path: 'customer-service',
        component: () => import('@/pages/admin/site/customerService.vue'),
        name: 'Admin-Site-CustomerService',
        meta: {
          title: '客服配置',
          icon: 'el-icon-service',
        },
      },
      // {
      //   path: 'site-const-config',
      //   component: () => import('@/pages/admin/site/siteConstConfig.vue'),
      //   name: 'Admin-Site-SiteConstConfig',
      //   meta: {
      //     title: '站点配置',
      //     icon: 'el-icon-document',
      //   },
      // },
      // {
      //   path: 'system-config',
      //   component: () => import('@/pages/admin/site/systemConfig.vue'),
      //   name: 'Admin-Site-SystemConfig',
      //   meta: {
      //     title: '系统配置',
      //     icon: 'el-icon-s-tools',
      //   },
      // },
    ],
  },
]
export default routes
